<div #animatedDigit class="animated-digit">
  <span><b>Total: </b>{{digit | number : '1.1-1'}} km</span>
</div>
